import { Component, computed, input, output } from '@angular/core';
import type { IconName as FormaIconName } from '../icon/icon.types';
import { Button } from '../button/button';
import { ButtonGroup } from '../button-group/button-group';
import { Icon } from '../icon/icon';

export const BANNER_APPEARANCES = ['primary', 'secondary', 'alert', 'warning', 'info'] as const;
export type BannerAppearance = (typeof BANNER_APPEARANCES)[number];

@Component({
  selector: 'forma-banner',
  templateUrl: './banner.html',
  styleUrls: ['./banner.scss'],
  imports: [Button, ButtonGroup, Icon],
  host: {
    class: 'forma-banner',
    '[class]': 'hostClasses()',
  },
})
export class Banner {
  appearance = input<BannerAppearance>('primary');
  title = input<string | null>(null);
  text = input<string | null>(null);
  buttonLabel = input<string | null>(null);
  icon = input<FormaIconName | null>(null);
  inline = input(false);

  buttonClick = output<void>();

  buttonAppearance = computed(() => {
    switch (this.appearance()) {
      case 'primary':
      case 'secondary':
        return 'primary';
      case 'alert':
      case 'warning':
        return 'secondary';
      case 'info':
        return 'tertiary';
      default:
        return 'primary';
    }
  });
  protected hostClasses = computed(() => {
    const classes: Record<string, boolean> = {};
    for (const option of BANNER_APPEARANCES) {
      classes[`forma-banner--${option}`] = this.appearance() === option;
    }
    classes['forma-banner--inline'] = this.inline();
    return classes;
  });
}
